import request from '@/utils/request'
import host from '@/api/base/host'
import requestMini from '@/utils/request-mini'

// 会员权益
const path = host.path('dev', { dev: 'v1/goods' })
const mini = host.path('dev', { dev: 'v1/mini/goods' })
const miniAuth = host.path('dev', { dev: 'v1/mini/authentication' })
const v1 = host.path('dev', { dev: 'v1' })

const privilege = host.path('dev', { dev: 'v1/user/myinfo/privilege' })
const order = host.path('dev', { dev: 'v1/order' })
const user = host.path('dev', { dev: 'v1/user/myinfo' })
// 学习计划的接口
const academy = host.path('dev', { dev: 'v1/academy' })

export default {
  getCurrentTime(data) {
    return request({
      url: v1('common/currentTime'),
      method: 'post'
    })
  },
  getPrivilegeLevelByUserId(data) {
    return request({
      url: privilege('getPrivilegeLevelByUserId'),
      method: 'post',
      data
    })
  },
  getDetailByGoodsId(data) {
    const { busiType, activityId } = data
    let url = ''
    if (busiType === 'studyplan') {
      // 学习计划的商品详情
      url = academy('planDetail')
    } else if (activityId === 3) {
      url = path('getDetailByGoodsIdActivity')
    } else {
      // 通用查询商品详情
      url = path('getDetailByGoodsId')
    }
    return request({ url, method: 'post', data })
  },
  getDetailByGoodsIdMini(data) {
    let url = ''
    // 通用查询商品详情
    url = mini('getDetailByGoodsId')
    return requestMini({ url, method: 'post', data })
  },
  getAuthenticByUserId(data) {
    let url = ''
    // 查询认证结果
    url = miniAuth('getAuthenticByUserId')
    return requestMini({ url, method: 'post', data })
  },
  // 去认证
  authentication(data) {
    let url = ''
    // 查询认证结果
    url = miniAuth('authentication')
    return requestMini({ url, method: 'post', data })
  },
  // 去认证
  imageToken(data) {
    let url = ''
    // 查询认证结果
    url = v1('mini/oss/imageToken')
    // url = 'http://192.168.10.39:8082/v1/mini/oss/imageToken'
    return requestMini({ url, method: 'get', data })
  },

  joinTerm(data) {
    return request({ url: academy('join'), method: 'post', data })
  },

  // 1.2 获取礼品卡（扫单向街二维码）
  getGiftCard(data) {
    return request({ url: order('getGiftCard'), method: 'post', data })
  },
  // 获取商品购买信息
  getGoodsBuyInfo(data) {
    return request({ url: order('getGoodsBuyInfo'), method: 'post', data })
  },
  getCommonGoodsBuyInfo(data) {
    return request({ url: order('getCommonGoodsBuyInfo'), method: 'post', data })
  },
  // 激活码
  activationActive(data) {
    return request({ url: user('activationActive'), method: 'post', data })
  },
  getCampBuyUrl(data) {
    return request({ url: path('getCampBuyUrl'), method: 'post', data })
  }
}
